import React from "react";
import { Row, Col, Card, DatePicker } from "antd";
import moment from "moment";
import ModelWrapper from "../../../modal/ModelWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";

const RescheduleModal = ({
  isOpen,
  setIsOpen,
  selectedMailForReschedule,
  setSelectedMailForReschedule,
  newScheduleDate,
  setNewScheduleDate,
  isLoading,
  rescheduleScheduledMail
}) => (
<ModelWrapper
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            Reschedule Email
          </h3>
          <p className="font-14 text-secondry mb-0">
            Select a new date for the scheduled email
          </p>
        </div>
      }
      footer={null}
      show={isOpen}
      setShow={setIsOpen}
      width={500}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Row gutter={[24, 24]} style={{ padding: "20px 0" }}>
        {selectedMailForReschedule && (
          <>
            <Col span={24}>
              <Card type="inner" style={{ backgroundColor: "#f9f9f9" }}>
                <div className="font-14 font-medium text-primary mb-8">
                  Current Schedule
                </div>
                <div className="font-12 text-secondry">
                  Video: {selectedMailForReschedule.metadata.videoName}
                </div>
                {/* <div className="font-12 text-secondry">
                  Current Time:{" "}
                  {moment(selectedMailForReschedule.scheduledTime).format(
                    "DD MMM YYYY, HH:mm"
                  )}
                </div> */}
              </Card>
            </Col>

            <Col span={24}>
              <div
                className="font-medium mb-12"
                style={{ color: "var(--primary-text-color)" }}
              >
                New Schedule Date{" "}
                <span style={{ color: "#ff4d4f" }}>*</span>
              </div>
              <DatePicker
                  // showTime={{
                  //   format: "HH:mm",
                  //   minuteStep: 15,
                  //   hideDisabledOptions: true,
                  // }}
                format="YYYY-MM-DD"
                placeholder="Select new date"
                style={{ width: "100%" }}
                size="large"
                value={newScheduleDate}
                onChange={setNewScheduleDate}
                disabled={isLoading}
                disabledDate={(current) => {
                  return current && current < moment().startOf("day");
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </Col>

            <Col span={24} className="d-flex justify-end gap-12 mt-16">
              <CustomSecondaryButton
                onClick={() => {
                  setIsOpen(false);
                  setSelectedMailForReschedule(null);
                  setNewScheduleDate(null);
                }}
                disabled={isLoading}
                size="large"
              >
                Cancel
              </CustomSecondaryButton>
              <CustomButton
                onClick={rescheduleScheduledMail}
                loading={isLoading}
                disabled={!newScheduleDate}
                size="large"
              >
                {isLoading ? "Rescheduling..." : "Reschedule"}
              </CustomButton>
            </Col>
          </>
        )}
      </Row>
    </ModelWrapper>
);

export default RescheduleModal; 